<template>
  <div testek="base-detail" class="p-10">
    <div class="flex">
      <div class="flex-3">
        <div class="header">
          <slot name="header" testek="header-base-detail"></slot>
        </div>
        <div class="content">
          <slot name="content" testek="content-base-detail"></slot>
        </div>
        <div class="footer">
          <div class="flex columns-2 mt-4">
            <div class="view-detail mt-6 w-full">
              <div class="flex w-full items-center">
                <div v-if="titleDetail" class="min-w-28 font-bold">
                  {{ titleDetail }}
                </div>
                <div class="ml-2 w-full">
                  <a-input
                    :placeholder="titleDetail"
                    v-model:value="currentItem[idField]"
                  />
                </div>
              </div>
              <div class="flex justify-end mt-4">
                <h-button
                  :title="$t('i18nCommon.ViewDetail')"
                  :classButton="'rounded-2xl'"
                  :dissabled="!currentItem[idField]"
                  @click="viewDetail"
                  testek="btn-view-detail"
                ></h-button>
              </div>
            </div>
            <div class="w-full ml-10">
              <div class="font-bold min-w-28">
                {{ $t("i18nCommon.MessageResponse") }}
              </div>
              <div class="w-full">
                <h-textarea
                  :value="currentItem.messageResponse"
                  :rows="10"
                ></h-textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ml-10 flex-1">
        <CategoryMenu testek="category-menu"></CategoryMenu>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryMenu from "@/views/category/CategoryMenu.vue";
export default {
  name: "BaseDetail",
  components: {
    CategoryMenu,
  },
  data() {
    return {
      params: {},
    };
  },
  props: {
    titleDetail: {
      type: String,
      default: "",
    },
    placeholderDetail: {
      type: String,
      default: "",
    },
    messageResponse: {
      default: "",
      type: String,
    },
    currentItem: {},
    idField: {
      default: "id",
      type: String,
    },
  },

  methods: {
    viewDetail() {
      const me = this;
      let payload = { ...me.params };
      payload[me.idField] = me.currentItem[me.idField];
      
      me.$emit("viewDetail", payload);
    },
    addData() {
      const me = this;
      me.$emit("addData", me.params);
    },
    addMoreData() {
      const me = this;
      me.$emit("addMoreData", me.params);
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
